/**
 * Returns currently used webpack mode if the app was run/build using the `--env dev` flag.
 * This is used to enable / disable some parts of the app when run on dev build.
 * @see package.json scripts commands
 */
export const environmentMode =
    process.env.NODE_ENV === 'development' ? 'development' : 'production';
